import { create } from 'zustand';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { User } from '@/types';

interface State {
  user: User | null;
  isLoading: boolean;
  refetch: ((options?: RefetchOptions) => Promise<QueryObserverResult<User, Error>>) | null;
}

interface Action {
  setUser: (user: User | null) => void;
  updateUser: (userData: Partial<User>) => void;
  clearUser: () => void;
  setIsLoading: (isLoading: boolean) => void;
  setRefetch: (
    refetch: ((options?: RefetchOptions) => Promise<QueryObserverResult<User, Error>>) | null,
  ) => void;
  refetchUser: () => Promise<QueryObserverResult<User, Error>> | null;
}

const useUserStore = create<State & Action>((set, get) => ({
  user: null,
  isLoading: false,
  refetch: null,

  setUser: (user) => set({ user }),

  updateUser: (userData) => {
    const { user } = get();
    if (user) set({ user: { ...user, ...userData } });
  },

  setIsLoading: (isLoading) => set({ isLoading }),

  clearUser: () => set({ user: null }),

  setRefetch: (refetch) => set({ refetch }),

  refetchUser: () => {
    const { refetch } = get();
    return refetch ? refetch() : null;
  },
}));

export default useUserStore;
